import React from "react";

const CFTag = ({ label, onRemove }) => {
  return (
    <span className="bg-white dark:bg-gray-800 py-[2px] px-[8px] border-solid border-[1px] border-slate-300 dark:border-slate-600 rounded-xl flex items-center cursor-pointer text-gray-900 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150">
      {label}
      <svg
        onClick={onRemove}
        width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
        className="ml-1 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-full p-0.5 transition-colors duration-150"
      >
        <path d="M10.6654 5.33325L5.33203 10.6666M10.6654 10.6666L5.33203 5.33325" stroke="currentColor" strokeWidth="2" strokeLinecap="round"></path>
      </svg>
    </span>
  );
};

export default CFTag;
